export default {
    default:      'default',
    noBorderLeft: 'noBorderLeft',
};
